import axios from "axios";

const HOST = "https://europe-central2-itc-bussoft.cloudfunctions.net";

export const customAxios = (token, pac, fn = "esir") => axios.create({
    baseURL: `${HOST}/${fn}/`,
    headers: {
        'client_os': 'web',
        'client_app': 'busSoft',
        'client_version': '26',
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`,
        "PAC": pac,
    },
    withCredentials: false,
});
